import { Alert, AlertColor, Snackbar as MuiSnackBar } from "@mui/material";
import React from "react";
import { useEffect, useState } from "react";
import { theme } from "@compass/core";
import { useSelector } from "react-redux";
import { RootState } from "redux/store";

export interface ActionMessage {
  key: number;
  message: string;
  alertColor: AlertColor;
}

export interface State {
  open: boolean;
  snackPack: readonly ActionMessage[];
  messageInfo?: ActionMessage;
}

export const ActionMessage = () => {
  const toast = useSelector((state: RootState) => state.app.toast);
  const [snackPack, setSnackPack] = useState<readonly ActionMessage[]>([]);
  const [open, setOpen] = useState(false);
  const [messageInfo, setMessageInfo] = useState<ActionMessage | undefined>(undefined);

  useEffect(() => {
    if (snackPack.length && !messageInfo) {
      // Set a new snack when we don't have an active one
      setMessageInfo({ ...snackPack[0] });
      setSnackPack((prev) => prev.slice(1));
      setOpen(true);
    } else if (snackPack.length && messageInfo && open) {
      // Close an active snack when a new one is added
      setOpen(false);
    }
  }, [snackPack, messageInfo, open]);

  useEffect(() => {
    if (toast) {
      setSnackPack((prev) => [...prev, { key: toast.timeSent, message: toast.message, alertColor: toast.alertColor }]);
    }
  }, [toast]);

  const handleClose = (event: React.SyntheticEvent | Event, reason?: string) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };

  const handleExited = () => {
    setMessageInfo(undefined);
  };

  return (
    <MuiSnackBar
      key={messageInfo ? messageInfo.key : undefined}
      open={open}
      autoHideDuration={6000}
      onClose={handleClose}
      TransitionProps={{ onExited: handleExited }}
      message={messageInfo ? messageInfo.message : undefined}
    >
      <Alert severity={messageInfo?.alertColor} variant="filled" sx={{ fontWeight: theme.typography.fontWeightBold }}>
        {messageInfo?.message}
      </Alert>
    </MuiSnackBar>
  );
}
